import React from "react";
import { Card, Button, Typography, Space } from "antd";

const { Title, Paragraph, Text } = Typography;

export default function Volumes() {
  return (
    <Space
      direction="vertical"
      size="large"
      style={{ width: "100%" }}
    >
      <Card>
        <Title level={5}>VOLUMES</Title>

        <Paragraph>
          Volumes offer highly available and reliable SSD-based
          storage space for your cloud servers. You can expand
          each volume up to <b>10 TB</b> at any time.
        </Paragraph>

        <Paragraph>
          <Text type="secondary">
            There is no volume attached to this server yet.
          </Text>
        </Paragraph>

        <Space>
          <Button danger type="primary">
            Create Volume
          </Button>
          <Button disabled>Attach volume</Button>
        </Space>
      </Card>
    </Space>
  );
}
